import Vue from 'vue';
import { Popup, Search, RadioGroup, Radio, Calendar, Dialog, List, Cascader, Image, IndexBar, IndexAnchor, Overlay, Progress } from 'vant';

Vue.use(Popup);
Vue.use(Search);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(List);
Vue.use(Dialog);
Vue.use(Cascader);
Vue.use(Image);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Overlay);
Vue.use(Progress);
Vue.use(Calendar);
